var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c("el-alert", {
        staticClass: "bairun-margin-b",
        attrs: {
          title: "不支持跨月查询，若有需求可分段筛选时间后操作",
          type: "error",
          closable: false
        }
      }),
      _c("SearchTerm", {
        attrs: {
          searchInfo: _vm.searchInfo,
          searchMore: true,
          searchBaseItems: [
            "sellerId",
            "shiftDate",
            "createdAtStart",
            "mobile"
          ],
          btns: { search: true, reset: true, download: _vm.downloading }
        },
        on: { onChange: _vm.onSearchChange }
      }),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          small: "",
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark",
            height: "45rem"
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: "下单时间", prop: "createdAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("formatDatePayAt")(scope.row.createdAt))
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "站点", prop: "sellerName" }
          }),
          _c("el-table-column", { attrs: { label: "条码", prop: "goodsNo" } }),
          _c("el-table-column", {
            attrs: { label: "商品", prop: "goodsName" }
          }),
          _c("el-table-column", {
            attrs: { label: "零售价", prop: "goodsPrice" }
          }),
          _c("el-table-column", { attrs: { label: "数量", prop: "goodsNum" } }),
          _c("el-table-column", {
            attrs: { label: "总价", prop: "orderSaleAmount" }
          }),
          _c("el-table-column", { attrs: { label: "实收", prop: "tradePay" } }),
          _c("el-table-column", {
            attrs: { label: "促销优惠", prop: "sellerDiscountAmount" }
          }),
          _c("el-table-column", {
            attrs: { label: "券优惠", prop: "couponDiscountAmount" }
          }),
          _c("el-table-column", {
            attrs: { label: "积分优惠", prop: "pointDiscountAmount" }
          }),
          _c("el-table-column", {
            attrs: { label: "消费类型", prop: "orderTypeName" }
          }),
          _c("el-table-column", {
            attrs: { label: "结算方式", prop: "payChannelName" }
          }),
          _c("el-table-column", {
            attrs: { label: "是否会员", prop: "isMember" }
          }),
          _c("el-table-column", { attrs: { label: "手机号", prop: "mobile" } }),
          _c("el-table-column", {
            attrs: { label: "主订单号", prop: "mainOrderNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "支付时间", prop: "payAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDatePayAt")(scope.row.payAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "退款时间", prop: "refundAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("formatDatePayAt")(scope.row.refundAt))
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "退款金额", prop: "orderRefund" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }